export default __webpack_public_path__ + "static/media/basil.7897f494.png";